// Domain configuration for different environments
const domainConfig = {
  // Development environment
  development: {
    subdomainSuffix: 'fly-social.co.in',
    landingPrefix: 'landing-',
    storesPrefix: 'stores-'
  },
  // UAT environment
  uat: {
    subdomainSuffix: 'fly-social.in',
    landingPrefix: 'landing-',
    storesPrefix: 'stores-'
  },
  // Production environment
  production: {
    subdomainSuffix: 'fly-social.site',
    landingPrefix: 'landing-',
    storesPrefix: 'stores-'
  }
};

// Get current environment
const getCurrentEnvironment = () => {
  if (process.env.VUE_APP_ENV === 'production') {
    return 'production';
  } else if (process.env.VUE_APP_ENV === 'uat') {
    return 'uat';
  } else {
    return 'development';
  }
};

// Get domain configuration for current environment
const getDomainConfig = () => {
  const env = getCurrentEnvironment();
  return domainConfig[env];
};

// Check if current hostname matches the expected domain suffix
const isExpectedDomain = (hostname) => {
  const config = getDomainConfig();
  return hostname.endsWith(config.subdomainSuffix);
};

// Get full subdomain URL for a given subdomain name
const getSubdomainUrl = (subdomainName, type = 'landing') => {
  const config = getDomainConfig();
  const prefix = type === 'landing' ? config.landingPrefix : config.storesPrefix;
  return `${prefix}${subdomainName}.${config.subdomainSuffix}`;
};

// Extract subdomain name from hostname
const extractSubdomainName = (hostname, type = 'landing') => {
  const config = getDomainConfig();
  const prefix = type === 'landing' ? config.landingPrefix : config.storesPrefix;
  
  if (hostname.startsWith(prefix)) {
    const subdomainPart = hostname.substring(prefix.length);
    // Remove the domain suffix
    const domainSuffix = config.subdomainSuffix;
    if (subdomainPart.endsWith(domainSuffix)) {
      return subdomainPart.substring(0, subdomainPart.length - domainSuffix.length - 1); // -1 for the dot
    }
  }
  return null;
};

// Check if hostname is a valid subdomain
const isValidSubdomain = (hostname, type = 'landing') => {
  const config = getDomainConfig();
  const prefix = type === 'landing' ? config.landingPrefix : config.storesPrefix;
  
  return hostname.startsWith(prefix) && hostname.endsWith(config.subdomainSuffix);
};

// Validate custom domain format
const isValidCustomDomain = (domain) => {
  if (!domain) return false;
  
  // Basic domain validation
  const domainRegex = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  
  if (!domainRegex.test(domain)) return false;
  
  if (domain.length > 253) return false;
  
  // Check if it's a subdomain format
  const parts = domain.split('.');
  if (parts.length < 2) return false;
  
  return true;
};

// Get CNAME target for custom domain
const getCustomDomainCnameTarget = (subdomainName, type = 'stores') => {
  const config = getDomainConfig();
  const prefix = type === 'landing' ? config.landingPrefix : config.storesPrefix;
  return `${prefix}${subdomainName}.${config.subdomainSuffix}`;
};

// Extract domain parts for DNS configuration
const getDomainParts = (customDomain) => {
  if (!customDomain) return null;
  
  const parts = customDomain.split('.');
  if (parts.length < 2) return null;
  
  return {
    subdomain: parts[0],
    domain: parts.slice(1).join('.')
  };
};

export {
  domainConfig,
  getCurrentEnvironment,
  getDomainConfig,
  isExpectedDomain,
  getSubdomainUrl,
  extractSubdomainName,
  isValidSubdomain,
  isValidCustomDomain,
  getCustomDomainCnameTarget,
  getDomainParts
}; 